"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "23", height: "26", viewBox: "0 0 23 26", className: "Icon export-pdf", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "defs",
            null,
            _react2.default.createElement("path", { id: "a-export-pdf", d: "M0 4h12v7H0z" }),
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "b-export-pdf" },
                _react2.default.createElement("feOffset", { dy: "-1", "in": "SourceAlpha", result: "shadowOffsetInner1" }),
                _react2.default.createElement("feComposite", { "in": "shadowOffsetInner1", in2: "SourceAlpha", operator: "arithmetic", k2: "-1", k3: "1", result: "shadowInnerInner1" }),
                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0", "in": "shadowInnerInner1", result: "shadowMatrixInner1" }),
                _react2.default.createElement("feOffset", { dx: "1", "in": "SourceAlpha", result: "shadowOffsetInner2" }),
                _react2.default.createElement("feComposite", { "in": "shadowOffsetInner2", in2: "SourceAlpha", operator: "arithmetic", k2: "-1", k3: "1", result: "shadowInnerInner2" }),
                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0", "in": "shadowInnerInner2", result: "shadowMatrixInner2" }),
                _react2.default.createElement(
                    "feMerge",
                    null,
                    _react2.default.createElement("feMergeNode", { "in": "shadowMatrixInner1" }),
                    _react2.default.createElement("feMergeNode", { "in": "shadowMatrixInner2" })
                )
            )
        ),
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#CACACA", d: "M3 0v26h20V6.999L16 0z" }),
            _react2.default.createElement("path", { fill: "#FFF", d: "M4 1h11v7h7v17H4z" }),
            _react2.default.createElement("path", { fill: "#FFF", d: "M16 1.417l5.581 5.582H16z" }),
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("use", { fill: "#E60B0B", xlinkHref: "#a-export-pdf" }),
                _react2.default.createElement("use", { fill: "#000", filter: "url(#b-export-pdf)", xlinkHref: "#a-export-pdf" })
            )
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/export-pdf.js
// module id = 1802
// module chunks = 0